import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '@app/shared';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { NgSelectModule } from '@ng-select/ng-select';
import { ChecklistService } from '@services/checklist.service';
import { ProductService } from '@services/product.service';
import { AppPurchaseOrderService } from '@services/purchase-order.service';
import { MentionModule } from 'angular-mentions';
import { DxDataGridModule, DxTreeListModule } from 'devextreme-angular';
import { DragulaModule } from 'ng2-dragula';
import { NgxLoadingModule } from 'ngx-loading';
import { StickyDirectiveModule } from 'ngx-sticky-directive';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ChecklistModule } from '../checklist/checklist.module';
import { PoDetailsModule } from '../po-details/po-details.module';
import { WorkflowsModule } from '../workflows/workflows.module';
import { ChecklistComponent } from './components/checklist/checklist.component';
import { LineItemsListComponent } from './components/line-items-list/line-items-list.component';
import { PoInvoiceListComponent } from './components/po-invoice-list/po-invoice-list.component';
import { PoReportsComponent } from './components/po-reports/po-reports.component';
import { PoSubscribersComponent } from './components/po-subscribers/po-subscribers.component';
import { PoSupplierTermsComponent } from './components/po-supplier-terms/po-supplier-terms.component';
import { PurchaseOrderComponent } from './components/purchase-order/purchase-order.component';
import { ChecklistStepComponent } from './containers/purchase-order-creation/checklist-step/checklist-step.component';
import { FilesStepComponent } from './containers/purchase-order-creation/files-step/files-step.component';
import { PoInfoStepComponent } from './containers/purchase-order-creation/po-info-step/po-info-step.component';
import { PoReviewStepComponent } from './containers/purchase-order-creation/po-review-step/po-review-step.component';
import { PoSubscribersStepComponent } from './containers/purchase-order-creation/po-subscribers-step/po-subscribers-step.component';
import { PurchaseOrderCreationComponent } from './containers/purchase-order-creation/purchase-order-creation.component';
import { PurchaseOrderDeletedComponent } from './containers/purchase-order-deleted/purchase-order-deleted.component';

import { PurchaseOrderDetailComponent } from './containers/purchase-order-detail/purchase-order-detail.component';
import { PurchaseOrderDraftsComponent } from './containers/purchase-order-drafts/purchase-order-drafts.component';
import { PoInvoiceDetailComponent } from './modals/po-invoice-detail/po-invoice-detail.component';
import { PurchaseOrderInvoiceFormComponent } from './modals/purchase-order-invoice-form/purchase-order-invoice-form.component';
import { RcdssApplicationFormModalComponent } from './modals/rcdss-application-form-modal/rcdss-application-form-modal.component';
import { SavedChecklistsModalComponent } from './modals/saved-checklists-modal/saved-checklists-modal.component';
import { TaskFilesModalComponent } from './modals/task-files-modal/task-files-modal.component';
import { VoucherCreationModalComponent } from './modals/voucher-creation-modal/voucher-creation-modal.component';

import { PurchaseOrderRoutingModule } from './purchase-order-routing.module';
import { PurchaseOrderSimpleComponent } from './components/purchase-order-simple/purchase-order-simple.component';
import { PurchaseOrderNormalComponent } from './components/purchase-order-normal/purchase-order-normal.component';
import { TaskListModalComponent } from './modals/task-list-modal/task-list-modal.component';
import { SubscriberListModalComponent } from './modals/subscriber-list-modal/subscriber-list-modal.component';
import { PrintRcdssApplicationFormComponent } from '@app/modules/purchase-order/components/print-rcdss-application-form/print-rcdss-application-form.component';
import { SordFormModalComponent } from './modals/sord-form-modal/sord-form-modal.component';
import { RcdssContractModalComponent } from './modals/rcdss-contract-modal/rcdss-contract-modal.component';
import { PoCommentsComponent } from './components/po-comments/po-comments.component';
import { UnitModal } from './modals/units-modal/unit.modal';
import { FinancialReportModal } from './modals/financial-report/financial-report.modal';
import { MatChipsModule } from '@angular/material/chips';
import { FinancialReportTypeModal } from './modals/financial-report/financial-report-type/financial-report-type.modal';
import { MatListModule } from '@angular/material/list';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { VoucherGenerationModalComponent } from './modals/financial-report/voucher-generation-modal/voucher-generation-modal.component';

const MODALS = [
  SavedChecklistsModalComponent,
  TaskFilesModalComponent,
  VoucherCreationModalComponent,
  PurchaseOrderInvoiceFormComponent,
  RcdssApplicationFormModalComponent,
  PoInvoiceDetailComponent,
  TaskListModalComponent,
  SubscriberListModalComponent,
  UnitModal,
  FinancialReportModal,
  FinancialReportTypeModal
];

@NgModule({
  imports: [
    CommonModule,
    PurchaseOrderRoutingModule,
    MatTabsModule,
    MatIconModule,
    PoDetailsModule,
    WorkflowsModule,
    NgSelectModule,
    NgOptionHighlightModule,
    DxDataGridModule,
    DxTreeListModule,
    FormsModule,
    MatButtonModule,
    MatStepperModule,
    SharedModule,
    MatDividerModule,
    ChecklistModule,
    MatRadioModule,
    MatTooltipModule,
    MatSlideToggleModule,
    NgxLoadingModule,
    MatDialogModule,
    MatProgressBarModule,
    MentionModule,
    DragulaModule,
    StickyDirectiveModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatListModule,
    DragDropModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule
  ],
  declarations: [
    PurchaseOrderDetailComponent,
    PurchaseOrderCreationComponent,
    PoSubscribersComponent,
    PoInfoStepComponent,
    PoReviewStepComponent,
    FilesStepComponent,
    ChecklistStepComponent,
    PoSubscribersStepComponent,
    PurchaseOrderComponent,
    ChecklistComponent,
    ...MODALS,
    TaskFilesModalComponent,
    PoReportsComponent,
    PurchaseOrderDraftsComponent,
    PurchaseOrderDeletedComponent,
    LineItemsListComponent,
    PoInvoiceListComponent,
    PoSupplierTermsComponent,
    PurchaseOrderSimpleComponent,
    PurchaseOrderNormalComponent,
    PrintRcdssApplicationFormComponent,
    SordFormModalComponent,
    RcdssContractModalComponent,
    PoCommentsComponent,
    VoucherGenerationModalComponent,
  ],
  exports: [
    PoSubscribersComponent,
    ...MODALS,
  ],
  providers: [
    AppPurchaseOrderService,
    ChecklistService,
    ProductService,
    {
      provide: MatDialogRef,
      useValue: {},
    },
  ],
  entryComponents: [
    PoSubscribersComponent,
    ...MODALS,
    PrintRcdssApplicationFormComponent,
    SordFormModalComponent,
    RcdssContractModalComponent,
  ],
})
export class PurchaseOrderModule {
}
